// External imports
import React, { useState } from "react";

// Internal imports
import {
    PageContainer,
    ProfileCard,
    Heading,
    Paragraph,
    Span,
    ButtonContainer,
    Button,
    Logo,
    ProfileTemplateGoBackButton,
} from "./ProfilePage.styles";
import { BiSolidLeftArrowCircle } from "react-icons/bi";
import DFN from "../../../assets/DFN.svg";
import MainPageLayout from "../../../components/core/header/MainPageLayout";
import { getUserRole } from "../../../core/LocalStorage/AuthSession/core";
import { useNavigate } from "react-router-dom";

// Translation
import { SupportedLanguage } from "../../../core/translations/supportedLanguages";
import { ProfilePageTranslations } from "./translations/types";
import { enTranslations } from "./translations/en";
import { deTranslations } from "./translations/de";
import { useLanguage } from "../../../core/translations/LanguageContext";

const TRANSLATIONS: Record<SupportedLanguage, ProfilePageTranslations> = {
    en: enTranslations,
    de: deTranslations,
};

const ProfilePage: React.FC = () => {
    // Get logged-in user role data
    const role = getUserRole();

    // translation
    const { language } = useLanguage();
    const translations = TRANSLATIONS[language];

    //Constant to show data of user
    const data = {
        email: "User1@example.com",
        institution: "Test",
        role: "Teacher",
        createdAt: "2024-11-18",
        gamesPlayed: 9,
        patientSeen: 6,
        currentLicense: "ABCLicense",
        licenseExpire: "2026-10-10",
    };
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };
    console.log("role", role)
    return (
        <MainPageLayout>
            <ProfileTemplateGoBackButton onClick={() => goBack()}>
                <BiSolidLeftArrowCircle />
                <span>{translations.goBack}</span>
            </ProfileTemplateGoBackButton>
            <PageContainer>
                <ProfileCard>
                    <Heading>{translations.heading}</Heading>
                    {data.email.includes("@") ? (
                        <Paragraph>
                            {translations.email}:
                            <Span>{data.email}</Span>
                        </Paragraph>
                    ) : (
                        <Paragraph>
                            {translations.user}:
                            <Span>{translations.dfn} {data.email}</Span>
                        </Paragraph>
                    )}
                    <Paragraph>
                        {translations.institution}: <Span> {data.institution}</Span>
                    </Paragraph>
                    <Paragraph>
                        {translations.role}: <Span>{data.role}</Span>
                    </Paragraph>
                    <Paragraph>
                        {translations.dateCreated}: <Span>{data.createdAt}</Span>
                    </Paragraph>
                    <Paragraph>
                        {translations.gamesPlayed}: <Span>{data.gamesPlayed}</Span>
                    </Paragraph>
                    <Paragraph>
                        {translations.patientsSeen}: <Span>{data.patientSeen}</Span>
                    </Paragraph>
                    <Paragraph>
                        {translations.currentLicense}: <Span>{data.currentLicense}</Span>
                    </Paragraph>
                    <Paragraph>
                        {translations.licenseExpiryDate}: <Span>{data.licenseExpire}</Span>
                    </Paragraph>
                    <ButtonContainer>
                        <Button href="#">{translations.changePassword}</Button>
                        {role?.toLowerCase() === "student" && (
                            <Button href="/badges">{translations.seeBadges}</Button>
                        )}
                        {(role?.toLowerCase() === "student" || role?.toLowerCase() === "teacher") && (
                            <Button href="/student/previous-classes">{translations.seeClasses}</Button>
                        )}
                    </ButtonContainer>
                </ProfileCard>
            </PageContainer>
        </MainPageLayout>
    );
};

export default ProfilePage;
